import React from 'react';

import lang from '../../lib/language';

import iconClose from '../../assets/img/close-line.svg';
import { useIsMobile } from '../../hooks';
import BaseModal from '../BaseModal/BaseModal';
import { ButtonTypesEnum } from '../Button/Button.types';
import ClickableImage from '../ClickableImage/ClickableImage';
import { Button } from '../index';

import styles from './HighLowLimitPriceAlert.module.scss';

type Props = {
  isBuyOrder: boolean;
  toggleModal: () => void;
  processModal: () => void;
};

const HighLowLimitPriceAlert = ({ toggleModal, processModal, isBuyOrder }: Props) => {
  const isMobile = useIsMobile();

  return (
    <BaseModal
      isOpen
      customStyle={
        isMobile
          ? {
            paddingBottom: 74,
            margin: 0,
            width: window.innerWidth,
            marginTop: window.innerHeight / 2.7,
            position: 'fixed',
            alignSelf: 'flex-end',
          }
          : undefined
      }
    >
      <div className={styles.titleAndClose}>
        <h6 className={styles.title}>
          {lang.webTradingHighLowLimitPriceAlert(
            isBuyOrder ? lang.webTradingHighLowLimitPriceAlertHigh() : lang.webTradingHighLowLimitPriceAlertLow(),
          )}
        </h6>
        {isMobile && <ClickableImage src={iconClose} onClick={toggleModal} />}
      </div>
      <div className={styles.content}>
        <p>
          {lang.webTradingHighLowLimitPriceAlertDescription(
            isBuyOrder ? lang.webTradingHighLowLimitPriceAlertHigher() : lang.webTradingHighLowLimitPriceAlertLower(),
          )}
        </p>
      </div>
      <div className={styles.actions}>
        <Button fullWidth onClick={toggleModal} className={styles.button}>
          {lang.webTradingEditPriceButton()}
        </Button>
        <Button variant={ButtonTypesEnum.Tertiary} fullWidth onClick={processModal}>
          {lang.commonContinueButton()}
        </Button>
      </div>
    </BaseModal>
  );
};

export default HighLowLimitPriceAlert;
